<template>
	<div clss="question-script">
		<Main />
	</div>
</template>

<script>
import Main from './components/Main'

export default {
  name: 'app',
  components: {
	Main
  },
  computed: {
	  quiz: function(){
		  return this.$store.getters.quiz
	  }
  }
}
</script>

<style lang="scss">
* {
	margin: 0;
	padding: 0;
}

body {
	font-family: $fontFamily;
	color: #333;
	background: #fff;
	font-size: 15px;
}

</style>
